// extracted by mini-css-extract-plugin
export default {"navbar":"RootLayout_navbar__z8+KG","contentArea":"RootLayout_contentArea__url4-","logoHeader":"RootLayout_logoHeader__iIbLp","wrapper":"RootLayout_wrapper__5h6HI"};